import { useState } from 'react';
import { useT } from '../i18n';
import { Dialog, DialogSurface, DialogBody, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  grid: { display: 'flex', flexWrap: 'wrap', gap: tokens.spacingHorizontalS },
  thumb: {
    width: '64px', height: '64px', objectFit: 'cover', borderRadius: tokens.borderRadiusMedium,
    cursor: 'pointer', border: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  fullImage: { maxWidth: '90vw', maxHeight: '85vh', objectFit: 'contain' as const },
});

export function ScoutingPhotoGallery({ photoUrls }: { photoUrls: string[] }) {
  const s = useStyles();
  const t = useT();
  const [selected, setSelected] = useState<string | null>(null);

  if (!photoUrls || photoUrls.length === 0) return null;

  return (
    <>
      <div className={s.grid}>
        {photoUrls.map((url) => (
          <img
            key={url}
            src={url}
            alt={t.crop.scoutPhotoAlt}
            className={s.thumb}
            onClick={() => setSelected(url)}
          />
        ))}
      </div>
      <Dialog open={!!selected} onOpenChange={(_, d) => !d.open && setSelected(null)}>
        <DialogSurface>
          <DialogBody>
            {selected && <img src={selected} alt={t.crop.scoutPhotoAltZoom} className={s.fullImage} />}
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </>
  );
}
